module.exports = __webpack_public_path__ + "img/home-bg-2.a7454782.png";